import { render } from "./Experience_en.vue?vue&type=template&id=e827120e&scoped=true"
import script from "./Experience_en.vue?vue&type=script&lang=js"
export * from "./Experience_en.vue?vue&type=script&lang=js"

import "@/assets/css/globalen.css?vue&type=style&index=0&id=e827120e&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e827120e"]])

export default __exports__